import { useEffect } from 'react'

import { isSafeRelativeNavigationTarget } from '~/lib/navigation/football-core'

export function CompleteAuthReturnTarget({ returnTo }: { returnTo?: string }) {
  useEffect(() => {
    if (!returnTo || !window.location.hash || !isSafeRelativeNavigationTarget(returnTo))
      return

    const target = new URL(returnTo, 'https://ballpeek.invalid')
    if (target.hash)
      return

    target.hash = window.location.hash
    const current = new URL(window.location.href)
    current.searchParams.set('returnTo', `${target.pathname}${target.search}${target.hash}`)
    current.hash = ''
    window.location.replace(current.toString())
  }, [returnTo])

  return null
}
